
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    content: String,
  },
})
export default class MetricHighlight extends Vue {
  title!: string;
}
